import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  header: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    fontSize: 14,
  },
  accordion: {
    backgroundColor: "transparent !important",
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    boxShadow: theme.shadows[3],

    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  accordionSummary: {
    backgroundColor: "white !important",
    borderRadius: 8,

    "& .MuiAccordionSummary-expandIcon": {
      color: "black",
    },
  },
  accordionDetail: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  marginGrid: {
    marginBottom: theme.spacing(2),
  },
  alertCustom: {
    borderRadius: 8,
    paddingBottom: 0,
  },
  alertContent: {
    marginTop: -12,
    marginBottom: -12,
  },
  marginDate: {
    marginBottom: "-10px",
  },
  marginPeriode: {
    marginLeft: "15px",
    paddingTop: "0px",
    fontSize: "1rem",
  },
  titreDatesSelect: {
    color: "#f50057",
    fontSize: "1.6em",
  },
  lvl2AccordionDetail: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  lvl3Accordion: {
    maxHeight: 300,
    overflow: "auto",
    marginTop: theme.spacing(1),
    borderRadius: 8,
    boxShadow: theme.shadows[1],
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 1 calc(33.333% - 16px)",
  },

  card: {
    marginTop: theme.spacing(2),
  },

  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
  },

  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
}));
